import React from 'react'
import styled, { withTheme } from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Text, Spacer } from 'components/atoms'
import placeholder from 'assets/imgs/placeholder-person.png'
import ContentLoader from 'react-content-loader';

const Loader = withTheme(({ theme }) => (
  <LoaderWrapper>
    <ContentLoader
      height={56}
      width={200}
      speed={1}
      primaryColor={theme.colors.bgAnimation}
      secondaryColor={theme.colors.bgLighterS}
      title="a carregar histórico..."
    >
      <rect width="200" height="24" />
    </ContentLoader>
  </LoaderWrapper>
));

const PersonInfo = ({
  image, name, email, isLoading,
}) => (
  <Person>
    {isLoading
      ? (<Person.ImagePlaceholder />)
      : (<Person.Image src={image || placeholder} alt={name} />)
    }

    {isLoading
      ? (
        <Loader />
      )
      : (
        <Person.Info>
          <Text modifiers={['weightBase', 'content']}>{name}</Text>
          <Spacer bottom="xs" />
          {email && (
            <a
              href={`mailto:${email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Text>{email}</Text>
            </a>
          )}
        </Person.Info>
      )}
  </Person>
)

const Person = styled.div`
  display: flex;
`

Person.Image = styled.img`
  width: 93px;
  height: 93px;
  background-color: ${props => props.theme.colors.bg};
  margin-right: ${props => props.theme.spacing.m};
  object-fit: cover;
  object-position: 50% 50%;
`

Person.ImagePlaceholder = styled.div`
  width: 93px;
  height: 93px;
  background-color: ${props => props.theme.colors.bgAnimation};
  margin-right: ${props => props.theme.spacing.m};
`

Person.Info = styled.div`

`

const LoaderWrapper = styled.div`
  width: 200px;
  height: 56px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

PersonInfo.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  email: PropTypes.string,
  isLoading: PropTypes.bool,
}

PersonInfo.defaultProps = {
  image: null,
  email: null,
  isLoading: false,
}

export default PersonInfo
